import React from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import AnimationSpinner from "../AnimationSpinner";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Numerology = () => {
	const [selectedCountry, setSelectedCountry] = useState("");
	const [selectedDate, setSelectedDate] = useState("");
	const [number, setNumber] = useState("");
	const [userName, setUserName] = useState("");
	const [email, setEmail] = useState("");
	const [orderReport, setOrderReport] = useState(""); // instead of checkbox
	const [isSubmitted, setIsSubmitted] = useState(false); // flag stops user to immediately submit again
	const [firstSubmit, setFirstSubmit] = useState(false); //to show errros only after first submission
	const [countryCodes, setCountryCodes] = useState([]);
	const [loading, setLoading] = useState(false);
	const [reason, setReason] = useState("");
	const [otherReason, setOtherReason] = useState("");
	const [errors, setErrors] = useState({
		country: "",
		date: "",
		number: "",
		username: "",
		email: "",
		orderReport: "",
		reason: "",
		OtherReason: "",
	});
	const reasonOptions = [
		{ value: "Price Seems High", label: "Price Seems High" },
		{ value: "Need Discount Coupon", label: "Need Discount Coupon" },
		{
			value: "Didn't Understand What is Full Report",
			label: "Didn't Understand What is Full Report",
		},
		{
			value: "Need Only Lucky Name & Signature",
			label: "Need Only Lucky Name & Signature",
		},
		{
			value: "I don't need 10x Luck Report",
			label: "I don't need 10x Luck Report",
		},
		{ value: "Other", label: "Other" },
	];

	const navigate = useNavigate();
	const countryCodesPre = [
		{
			name: "Select country code",
			dial_code: "",
		},
		{
			name: "Afghanistan",
			dial_code: "+93",
			code: "AF",
		},
		{
			name: "Aland Islands",
			dial_code: "+358",
			code: "AX",
		},
		{
			name: "Albania",
			dial_code: "+355",
			code: "AL",
		},
		{
			name: "Algeria",
			dial_code: "+213",
			code: "DZ",
		},
		{
			name: "AmericanSamoa",
			dial_code: "+1684",
			code: "AS",
		},
		{
			name: "Andorra",
			dial_code: "+376",
			code: "AD",
		},
		{
			name: "Angola",
			dial_code: "+244",
			code: "AO",
		},
		{
			name: "Anguilla",
			dial_code: "+1264",
			code: "AI",
		},
		{
			name: "Antarctica",
			dial_code: "+672",
			code: "AQ",
		},
		{
			name: "Antigua and Barbuda",
			dial_code: "+1268",
			code: "AG",
		},
		{
			name: "Argentina",
			dial_code: "+54",
			code: "AR",
		},
		{
			name: "Armenia",
			dial_code: "+374",
			code: "AM",
		},
		{
			name: "Aruba",
			dial_code: "+297",
			code: "AW",
		},
		{
			name: "Australia",
			dial_code: "+61",
			code: "AU",
		},
		{
			name: "Austria",
			dial_code: "+43",
			code: "AT",
		},
		{
			name: "Azerbaijan",
			dial_code: "+994",
			code: "AZ",
		},
		{
			name: "Bahamas",
			dial_code: "+1242",
			code: "BS",
		},
		{
			name: "Bahrain",
			dial_code: "+973",
			code: "BH",
		},
		{
			name: "Bangladesh",
			dial_code: "+880",
			code: "BD",
		},
		{
			name: "Barbados",
			dial_code: "+1246",
			code: "BB",
		},
		{
			name: "Belarus",
			dial_code: "+375",
			code: "BY",
		},
		{
			name: "Belgium",
			dial_code: "+32",
			code: "BE",
		},
		{
			name: "Belize",
			dial_code: "+501",
			code: "BZ",
		},
		{
			name: "Benin",
			dial_code: "+229",
			code: "BJ",
		},
		{
			name: "Bermuda",
			dial_code: "+1441",
			code: "BM",
		},
		{
			name: "Bhutan",
			dial_code: "+975",
			code: "BT",
		},
		{
			name: "Bolivia, Plurinational State of",
			dial_code: "+591",
			code: "BO",
		},
		{
			name: "Bosnia and Herzegovina",
			dial_code: "+387",
			code: "BA",
		},
		{
			name: "Botswana",
			dial_code: "+267",
			code: "BW",
		},
		{
			name: "Brazil",
			dial_code: "+55",
			code: "BR",
		},
		{
			name: "British Indian Ocean Territory",
			dial_code: "+246",
			code: "IO",
		},
		{
			name: "Brunei Darussalam",
			dial_code: "+673",
			code: "BN",
		},
		{
			name: "Bulgaria",
			dial_code: "+359",
			code: "BG",
		},
		{
			name: "Burkina Faso",
			dial_code: "+226",
			code: "BF",
		},
		{
			name: "Burundi",
			dial_code: "+257",
			code: "BI",
		},
		{
			name: "Cambodia",
			dial_code: "+855",
			code: "KH",
		},
		{
			name: "Cameroon",
			dial_code: "+237",
			code: "CM",
		},
		{
			name: "Canada",
			dial_code: "+1",
			code: "CA",
		},
		{
			name: "Cape Verde",
			dial_code: "+238",
			code: "CV",
		},
		{
			name: "Cayman Islands",
			dial_code: "+ 345",
			code: "KY",
		},
		{
			name: "Central African Republic",
			dial_code: "+236",
			code: "CF",
		},
		{
			name: "Chad",
			dial_code: "+235",
			code: "TD",
		},
		{
			name: "Chile",
			dial_code: "+56",
			code: "CL",
		},
		{
			name: "China",
			dial_code: "+86",
			code: "CN",
		},
		{
			name: "Christmas Island",
			dial_code: "+61",
			code: "CX",
		},
		{
			name: "Cocos (Keeling) Islands",
			dial_code: "+61",
			code: "CC",
		},
		{
			name: "Colombia",
			dial_code: "+57",
			code: "CO",
		},
		{
			name: "Comoros",
			dial_code: "+269",
			code: "KM",
		},
		{
			name: "Congo",
			dial_code: "+242",
			code: "CG",
		},
		{
			name: "Congo, The Democratic Republic of the Congo",
			dial_code: "+243",
			code: "CD",
		},
		{
			name: "Cook Islands",
			dial_code: "+682",
			code: "CK",
		},
		{
			name: "Costa Rica",
			dial_code: "+506",
			code: "CR",
		},
		{
			name: "Cote d'Ivoire",
			dial_code: "+225",
			code: "CI",
		},
		{
			name: "Croatia",
			dial_code: "+385",
			code: "HR",
		},
		{
			name: "Cuba",
			dial_code: "+53",
			code: "CU",
		},
		{
			name: "Cyprus",
			dial_code: "+357",
			code: "CY",
		},
		{
			name: "Czech Republic",
			dial_code: "+420",
			code: "CZ",
		},
		{
			name: "Denmark",
			dial_code: "+45",
			code: "DK",
		},
		{
			name: "Djibouti",
			dial_code: "+253",
			code: "DJ",
		},
		{
			name: "Dominica",
			dial_code: "+1767",
			code: "DM",
		},
		{
			name: "Dominican Republic",
			dial_code: "+1849",
			code: "DO",
		},
		{
			name: "Ecuador",
			dial_code: "+593",
			code: "EC",
		},
		{
			name: "Egypt",
			dial_code: "+20",
			code: "EG",
		},
		{
			name: "El Salvador",
			dial_code: "+503",
			code: "SV",
		},
		{
			name: "Equatorial Guinea",
			dial_code: "+240",
			code: "GQ",
		},
		{
			name: "Eritrea",
			dial_code: "+291",
			code: "ER",
		},
		{
			name: "Estonia",
			dial_code: "+372",
			code: "EE",
		},
		{
			name: "Ethiopia",
			dial_code: "+251",
			code: "ET",
		},
		{
			name: "Falkland Islands (Malvinas)",
			dial_code: "+500",
			code: "FK",
		},
		{
			name: "Faroe Islands",
			dial_code: "+298",
			code: "FO",
		},
		{
			name: "Fiji",
			dial_code: "+679",
			code: "FJ",
		},
		{
			name: "Finland",
			dial_code: "+358",
			code: "FI",
		},
		{
			name: "France",
			dial_code: "+33",
			code: "FR",
		},
		{
			name: "French Guiana",
			dial_code: "+594",
			code: "GF",
		},
		{
			name: "French Polynesia",
			dial_code: "+689",
			code: "PF",
		},
		{
			name: "Gabon",
			dial_code: "+241",
			code: "GA",
		},
		{
			name: "Gambia",
			dial_code: "+220",
			code: "GM",
		},
		{
			name: "Georgia",
			dial_code: "+995",
			code: "GE",
		},
		{
			name: "Germany",
			dial_code: "+49",
			code: "DE",
		},
		{
			name: "Ghana",
			dial_code: "+233",
			code: "GH",
		},
		{
			name: "Gibraltar",
			dial_code: "+350",
			code: "GI",
		},
		{
			name: "Greece",
			dial_code: "+30",
			code: "GR",
		},
		{
			name: "Greenland",
			dial_code: "+299",
			code: "GL",
		},
		{
			name: "Grenada",
			dial_code: "+1473",
			code: "GD",
		},
		{
			name: "Guadeloupe",
			dial_code: "+590",
			code: "GP",
		},
		{
			name: "Guam",
			dial_code: "+1671",
			code: "GU",
		},
		{
			name: "Guatemala",
			dial_code: "+502",
			code: "GT",
		},
		{
			name: "Guernsey",
			dial_code: "+44",
			code: "GG",
		},
		{
			name: "Guinea",
			dial_code: "+224",
			code: "GN",
		},
		{
			name: "Guinea-Bissau",
			dial_code: "+245",
			code: "GW",
		},
		{
			name: "Guyana",
			dial_code: "+595",
			code: "GY",
		},
		{
			name: "Haiti",
			dial_code: "+509",
			code: "HT",
		},
		{
			name: "Holy See (Vatican City State)",
			dial_code: "+379",
			code: "VA",
		},
		{
			name: "Honduras",
			dial_code: "+504",
			code: "HN",
		},
		{
			name: "Hong Kong",
			dial_code: "+852",
			code: "HK",
		},
		{
			name: "Hungary",
			dial_code: "+36",
			code: "HU",
		},
		{
			name: "Iceland",
			dial_code: "+354",
			code: "IS",
		},
		{
			name: "India",
			dial_code: "+91",
			code: "IN",
		},
		{
			name: "Indonesia",
			dial_code: "+62",
			code: "ID",
		},
		{
			name: "Iran, Islamic Republic of Persian Gulf",
			dial_code: "+98",
			code: "IR",
		},
		{
			name: "Iraq",
			dial_code: "+964",
			code: "IQ",
		},
		{
			name: "Ireland",
			dial_code: "+353",
			code: "IE",
		},
		{
			name: "Isle of Man",
			dial_code: "+44",
			code: "IM",
		},
		{
			name: "Israel",
			dial_code: "+972",
			code: "IL",
		},
		{
			name: "Italy",
			dial_code: "+39",
			code: "IT",
		},
		{
			name: "Jamaica",
			dial_code: "+1876",
			code: "JM",
		},
		{
			name: "Japan",
			dial_code: "+81",
			code: "JP",
		},
		{
			name: "Jersey",
			dial_code: "+44",
			code: "JE",
		},
		{
			name: "Jordan",
			dial_code: "+962",
			code: "JO",
		},
		{
			name: "Kazakhstan",
			dial_code: "+77",
			code: "KZ",
		},
		{
			name: "Kenya",
			dial_code: "+254",
			code: "KE",
		},
		{
			name: "Kiribati",
			dial_code: "+686",
			code: "KI",
		},
		{
			name: "Korea, Democratic People's Republic of Korea",
			dial_code: "+850",
			code: "KP",
		},
		{
			name: "Korea, Republic of South Korea",
			dial_code: "+82",
			code: "KR",
		},
		{
			name: "Kuwait",
			dial_code: "+965",
			code: "KW",
		},
		{
			name: "Kyrgyzstan",
			dial_code: "+996",
			code: "KG",
		},
		{
			name: "Laos",
			dial_code: "+856",
			code: "LA",
		},
		{
			name: "Latvia",
			dial_code: "+371",
			code: "LV",
		},
		{
			name: "Lebanon",
			dial_code: "+961",
			code: "LB",
		},
		{
			name: "Lesotho",
			dial_code: "+266",
			code: "LS",
		},
		{
			name: "Liberia",
			dial_code: "+231",
			code: "LR",
		},
		{
			name: "Libyan Arab Jamahiriya",
			dial_code: "+218",
			code: "LY",
		},
		{
			name: "Liechtenstein",
			dial_code: "+423",
			code: "LI",
		},
		{
			name: "Lithuania",
			dial_code: "+370",
			code: "LT",
		},
		{
			name: "Luxembourg",
			dial_code: "+352",
			code: "LU",
		},
		{
			name: "Macao",
			dial_code: "+853",
			code: "MO",
		},
		{
			name: "Macedonia",
			dial_code: "+389",
			code: "MK",
		},
		{
			name: "Madagascar",
			dial_code: "+261",
			code: "MG",
		},
		{
			name: "Malawi",
			dial_code: "+265",
			code: "MW",
		},
		{
			name: "Malaysia",
			dial_code: "+60",
			code: "MY",
		},
		{
			name: "Maldives",
			dial_code: "+960",
			code: "MV",
		},
		{
			name: "Mali",
			dial_code: "+223",
			code: "ML",
		},
		{
			name: "Malta",
			dial_code: "+356",
			code: "MT",
		},
		{
			name: "Marshall Islands",
			dial_code: "+692",
			code: "MH",
		},
		{
			name: "Martinique",
			dial_code: "+596",
			code: "MQ",
		},
		{
			name: "Mauritania",
			dial_code: "+222",
			code: "MR",
		},
		{
			name: "Mauritius",
			dial_code: "+230",
			code: "MU",
		},
		{
			name: "Mayotte",
			dial_code: "+262",
			code: "YT",
		},
		{
			name: "Mexico",
			dial_code: "+52",
			code: "MX",
		},
		{
			name: "Micronesia, Federated States of Micronesia",
			dial_code: "+691",
			code: "FM",
		},
		{
			name: "Moldova",
			dial_code: "+373",
			code: "MD",
		},
		{
			name: "Monaco",
			dial_code: "+377",
			code: "MC",
		},
		{
			name: "Mongolia",
			dial_code: "+976",
			code: "MN",
		},
		{
			name: "Montenegro",
			dial_code: "+382",
			code: "ME",
		},
		{
			name: "Montserrat",
			dial_code: "+1664",
			code: "MS",
		},
		{
			name: "Morocco",
			dial_code: "+212",
			code: "MA",
		},
		{
			name: "Mozambique",
			dial_code: "+258",
			code: "MZ",
		},
		{
			name: "Myanmar",
			dial_code: "+95",
			code: "MM",
		},
		{
			name: "Namibia",
			dial_code: "+264",
			code: "NA",
		},
		{
			name: "Nauru",
			dial_code: "+674",
			code: "NR",
		},
		{
			name: "Nepal",
			dial_code: "+977",
			code: "NP",
		},
		{
			name: "Netherlands",
			dial_code: "+31",
			code: "NL",
		},
		{
			name: "Netherlands Antilles",
			dial_code: "+599",
			code: "AN",
		},
		{
			name: "New Caledonia",
			dial_code: "+687",
			code: "NC",
		},
		{
			name: "New Zealand",
			dial_code: "+64",
			code: "NZ",
		},
		{
			name: "Nicaragua",
			dial_code: "+505",
			code: "NI",
		},
		{
			name: "Niger",
			dial_code: "+227",
			code: "NE",
		},
		{
			name: "Nigeria",
			dial_code: "+234",
			code: "NG",
		},
		{
			name: "Niue",
			dial_code: "+683",
			code: "NU",
		},
		{
			name: "Norfolk Island",
			dial_code: "+672",
			code: "NF",
		},
		{
			name: "Northern Mariana Islands",
			dial_code: "+1670",
			code: "MP",
		},
		{
			name: "Norway",
			dial_code: "+47",
			code: "NO",
		},
		{
			name: "Oman",
			dial_code: "+968",
			code: "OM",
		},
		{
			name: "Pakistan",
			dial_code: "+92",
			code: "PK",
		},
		{
			name: "Palau",
			dial_code: "+680",
			code: "PW",
		},
		{
			name: "Palestinian Territory, Occupied",
			dial_code: "+970",
			code: "PS",
		},
		{
			name: "Panama",
			dial_code: "+507",
			code: "PA",
		},
		{
			name: "Papua New Guinea",
			dial_code: "+675",
			code: "PG",
		},
		{
			name: "Paraguay",
			dial_code: "+595",
			code: "PY",
		},
		{
			name: "Peru",
			dial_code: "+51",
			code: "PE",
		},
		{
			name: "Philippines",
			dial_code: "+63",
			code: "PH",
		},
		{
			name: "Pitcairn",
			dial_code: "+872",
			code: "PN",
		},
		{
			name: "Poland",
			dial_code: "+48",
			code: "PL",
		},
		{
			name: "Portugal",
			dial_code: "+351",
			code: "PT",
		},
		{
			name: "Puerto Rico",
			dial_code: "+1939",
			code: "PR",
		},
		{
			name: "Qatar",
			dial_code: "+974",
			code: "QA",
		},
		{
			name: "Romania",
			dial_code: "+40",
			code: "RO",
		},
		{
			name: "Russia",
			dial_code: "+7",
			code: "RU",
		},
		{
			name: "Rwanda",
			dial_code: "+250",
			code: "RW",
		},
		{
			name: "Reunion",
			dial_code: "+262",
			code: "RE",
		},
		{
			name: "Saint Barthelemy",
			dial_code: "+590",
			code: "BL",
		},
		{
			name: "Saint Helena, Ascension and Tristan Da Cunha",
			dial_code: "+290",
			code: "SH",
		},
		{
			name: "Saint Kitts and Nevis",
			dial_code: "+1869",
			code: "KN",
		},
		{
			name: "Saint Lucia",
			dial_code: "+1758",
			code: "LC",
		},
		{
			name: "Saint Martin",
			dial_code: "+590",
			code: "MF",
		},
		{
			name: "Saint Pierre and Miquelon",
			dial_code: "+508",
			code: "PM",
		},
		{
			name: "Saint Vincent and the Grenadines",
			dial_code: "+1784",
			code: "VC",
		},
		{
			name: "Samoa",
			dial_code: "+685",
			code: "WS",
		},
		{
			name: "San Marino",
			dial_code: "+378",
			code: "SM",
		},
		{
			name: "Sao Tome and Principe",
			dial_code: "+239",
			code: "ST",
		},
		{
			name: "Saudi Arabia",
			dial_code: "+966",
			code: "SA",
		},
		{
			name: "Senegal",
			dial_code: "+221",
			code: "SN",
		},
		{
			name: "Serbia",
			dial_code: "+381",
			code: "RS",
		},
		{
			name: "Seychelles",
			dial_code: "+248",
			code: "SC",
		},
		{
			name: "Sierra Leone",
			dial_code: "+232",
			code: "SL",
		},
		{
			name: "Singapore",
			dial_code: "+65",
			code: "SG",
		},
		{
			name: "Slovakia",
			dial_code: "+421",
			code: "SK",
		},
		{
			name: "Slovenia",
			dial_code: "+386",
			code: "SI",
		},
		{
			name: "Solomon Islands",
			dial_code: "+677",
			code: "SB",
		},
		{
			name: "Somalia",
			dial_code: "+252",
			code: "SO",
		},
		{
			name: "South Africa",
			dial_code: "+27",
			code: "ZA",
		},
		{
			name: "South Sudan",
			dial_code: "+211",
			code: "SS",
		},
		{
			name: "South Georgia and the South Sandwich Islands",
			dial_code: "+500",
			code: "GS",
		},
		{
			name: "Spain",
			dial_code: "+34",
			code: "ES",
		},
		{
			name: "Sri Lanka",
			dial_code: "+94",
			code: "LK",
		},
		{
			name: "Sudan",
			dial_code: "+249",
			code: "SD",
		},
		{
			name: "Suriname",
			dial_code: "+597",
			code: "SR",
		},
		{
			name: "Svalbard and Jan Mayen",
			dial_code: "+47",
			code: "SJ",
		},
		{
			name: "Swaziland",
			dial_code: "+268",
			code: "SZ",
		},
		{
			name: "Sweden",
			dial_code: "+46",
			code: "SE",
		},
		{
			name: "Switzerland",
			dial_code: "+41",
			code: "CH",
		},
		{
			name: "Syrian Arab Republic",
			dial_code: "+963",
			code: "SY",
		},
		{
			name: "Taiwan",
			dial_code: "+886",
			code: "TW",
		},
		{
			name: "Tajikistan",
			dial_code: "+992",
			code: "TJ",
		},
		{
			name: "Tanzania, United Republic of Tanzania",
			dial_code: "+255",
			code: "TZ",
		},
		{
			name: "Thailand",
			dial_code: "+66",
			code: "TH",
		},
		{
			name: "Timor-Leste",
			dial_code: "+670",
			code: "TL",
		},
		{
			name: "Togo",
			dial_code: "+228",
			code: "TG",
		},
		{
			name: "Tokelau",
			dial_code: "+690",
			code: "TK",
		},
		{
			name: "Tonga",
			dial_code: "+676",
			code: "TO",
		},
		{
			name: "Trinidad and Tobago",
			dial_code: "+1868",
			code: "TT",
		},
		{
			name: "Tunisia",
			dial_code: "+216",
			code: "TN",
		},
		{
			name: "Turkey",
			dial_code: "+90",
			code: "TR",
		},
		{
			name: "Turkmenistan",
			dial_code: "+993",
			code: "TM",
		},
		{
			name: "Turks and Caicos Islands",
			dial_code: "+1649",
			code: "TC",
		},
		{
			name: "Tuvalu",
			dial_code: "+688",
			code: "TV",
		},
		{
			name: "Uganda",
			dial_code: "+256",
			code: "UG",
		},
		{
			name: "Ukraine",
			dial_code: "+380",
			code: "UA",
		},
		{
			name: "United Arab Emirates",
			dial_code: "+971",
			code: "AE",
		},
		{
			name: "United Kingdom",
			dial_code: "+44",
			code: "GB",
		},
		{
			name: "United States",
			dial_code: "+1",
			code: "US",
		},
		{
			name: "Uruguay",
			dial_code: "+598",
			code: "UY",
		},
		{
			name: "Uzbekistan",
			dial_code: "+998",
			code: "UZ",
		},
		{
			name: "Vanuatu",
			dial_code: "+678",
			code: "VU",
		},
		{
			name: "Venezuela, Bolivarian Republic of Venezuela",
			dial_code: "+58",
			code: "VE",
		},
		{
			name: "Vietnam",
			dial_code: "+84",
			code: "VN",
		},
		{
			name: "Virgin Islands, British",
			dial_code: "+1284",
			code: "VG",
		},
		{
			name: "Virgin Islands, U.S.",
			dial_code: "+1340",
			code: "VI",
		},
		{
			name: "Wallis and Futuna",
			dial_code: "+681",
			code: "WF",
		},
		{
			name: "Yemen",
			dial_code: "+967",
			code: "YE",
		},
		{
			name: "Zambia",
			dial_code: "+260",
			code: "ZM",
		},
		{
			name: "Zimbabwe",
			dial_code: "+263",
			code: "ZW",
		},
	];
	// function for handling country change
	const handleCountryChange = (selceted) => {
		setSelectedCountry(selceted);
	};
	// function for handling reason change
	const handleReasonChange = (selceted) => {
		setReason(selceted);
	};

	// funciton for validating errors
	const validation = (submission) => {
		if (!firstSubmit && !submission) {
			return true; // is user is not even submitted form once validation will not run and dont show error when page load
		}

		let validationErrors = {};
		let hasErrors = false; // for returning value to avoid asynchronous operation

		if (!selectedCountry || selectedCountry.value.trim() === "") {
			validationErrors.country = "Country code is required.";
			hasErrors = true;
		}
		if (!selectedDate) {
			validationErrors.date = "Date of birth is required.";
			hasErrors = true;
		}
		if (!number || number.trim() === "") {
			validationErrors.number = "Phone number is required.";
			hasErrors = true;
		} else if (
			isNaN(number.replace(/\D/g, "")) ||
			number.replace(/\D/g, "").length !== 10
		) {
			validationErrors.number = "Please enter a valid 10-digit phone number.";
			hasErrors = true;
		}

		if (!userName || !userName.trim()) {
			validationErrors.username = "Name is required.";
			hasErrors = true;
		}
		if (!email || !email.trim()) {
			validationErrors.email = "Email is required.";
			hasErrors = true;
		} else if (
			!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)
		) {
			validationErrors.email = "Please enter a valid email address.";
			hasErrors = true;
		}
		if (orderReport == "") {
			validationErrors.orderReport = "Please select whether you ordered the report";
			hasErrors = true;
		}
		
		if(orderReport === "false") {
			if (!reason.value || reason.value.trim() === "") {
				validationErrors.reason = "Please select a reason.";
				hasErrors = true;
			}
			if (
				reason.value === "Other" &&
				(!otherReason || otherReason.trim() === "")
			) {
				validationErrors.OtherReason = "Please mention a reason.";
				hasErrors = true;
			}
		}
		if (hasErrors) {
			setErrors(validationErrors);
		} else {
			setErrors({
				country: "",
				date: "",
				number: "",
				username: "",
				email: "",
				reason: "",
				OtherReason: "",
			});
		}
		return hasErrors;
	};

	// core functions for handling submit and reset form
	const handleSubmit = (e) => {
		e.preventDefault();

		if (isSubmitted) {
			//if form is just submitted user cant submit again within 2 second
			return;
		}
		if (!firstSubmit) {
			setFirstSubmit(true); // if user is not submitted even once we will mark first submission
		}
		const hasError = validation(true);
		if (hasError) {
			return;
		} else {
			try {
				setLoading(true);
				const formData = new FormData();
				formData.append("name", userName);
				formData.append("email", email);
				formData.append("country_code", selectedCountry.value);
				formData.append("mobile_number", number);
				formData.append("dob", selectedDate);
				formData.append("luck_report_ordered", orderReport);
				if (orderReport == "false") {
					formData.append("reason", reason.value);
					if (reason.value === "Other") {
						formData.append("reason_other", otherReason);
					}
				}
				axios
					.post(
						`https://app.liveluckier.com/mobilenumerology/backend/client/save_client`,
						formData
					)
					.then((response) => {
						if (response.data.status === true) {
							setLoading(false);
							navigate("/report");
							setFirstSubmit(false);
							setIsSubmitted(true);
							setTimeout(() => {
								setIsSubmitted(false);
							}, 2000);

							// resetting error after successful submission
							setSelectedCountry(countryCodes[0]);
							setSelectedDate("");
							setNumber("");
							setUserName("");
							setEmail("");
							setErrors({
								country: "",
								date: "",
								number: "",
								username: "",
								email: "",
							});
						} else {
							// console.log("got the rejection response from api ")
							setLoading(false);
							if (response.data.errors) {
								const errorMessages = Object.values(response.data.errors).join(
									"\n"
								);
								Swal.fire({
									icon: "error",
									title: "Validation Errors",
									text: errorMessages,
								});
							} else {
								Swal.fire({
									icon: "error",
									title: "Error",
									text: response.data.message || "Something went wrong.",
								});
							}
						}
					});
			} catch (error) {
				setLoading(false);
				Swal.fire({
					icon: "error",
					title: "Error",
					text:
						error.response?.data?.message ||
						error.message ||
						"Something went wrong. Please try again.",
				});
			}
		}
	};

	const handleReset = (e) => {
		e.preventDefault();
		setSelectedCountry(countryCodes[0]);
		setSelectedDate("");
		setNumber("");
		setUserName("");
		setEmail("");
		setIsSubmitted(false);
		setErrors({
			country: "",
			date: "",
			number: "",
			username: "",
			email: "",
		});
	};

	// use effect for side effects
	useEffect(() => {
		const countryCodefinal = countryCodesPre.map((country) => ({
			label: country.dial_code + " " + country.name,
			value: country.dial_code,
		}));
		setCountryCodes(countryCodefinal);
	}, []);

	useEffect(() => {
		validation();
	}, [selectedCountry, selectedDate, number, userName, email, firstSubmit, orderReport,reason, otherReason]);

	useEffect(() => {
		if (orderReport === "yes") {
			setReason("");
			setOtherReason("");
		}
	}, [orderReport]);
	// -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
	return (
		<>
			<div className="row w-100" style={{overflow:"hidden"}}>
			<AnimationSpinner show={loading} />
				{/* <div className="information-container text-center col-11 mx-auto ">
                    <div className='title-container mx-auto'>
                        <h2>What is Numerology?</h2>
                        <hr />
                    </div>
                    <p>Numerology is an ancient belief system that assigns meaning to numbers, linking them to events and characteristics in life. By understanding these numbers, people can gain insights into their personalities, relationships, and life paths. Numerology operates on the principle that numbers carry vibrational energies that influence our lives.</p>
                </div> */}
				<div className="main-content col-12 px-4 mx-auto d-flex justify-content-center align-items-center ">
					<div className="sub-container d-flex flex-column justify-content-between align-items-center">
						<form className="w-100 form-container">
							<div className="d-flex flex-column gap-3">
								<div className="w-100 text-center">
									{/* <h1>Enter your details</h1> */}
									<h1>Submit Your Details For Mobile Numerology Report</h1>
								</div>

								<div className="row w-100 mx-auto">
									{/* dropdown container */}
									<div className="col-lg-12 pb-4">
										<div className="dropdown-container d-flex flex-column gap-1">
											<label htmlFor="options" className="form-label">
												Country code
											</label>
											<Select
												className="basic-single"
												classNamePrefix="select"
												defaultValue={countryCodes[0]}
												value={selectedCountry}
												isSearchable={true}
												name="countries"
												options={countryCodes}
												onChange={handleCountryChange}
												placeholder={"select country code"}
												styles={{
													control: (provided, state) => ({
														...provided,
														minHeight: "36px",
														fontSize: "13px",
														border: state.isFocused
															? "1px solid #86b7fe"
															: "1px solid #ccc",
														boxShadow: state.isFocused
															? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
															: null,
													}),
													indicatorContainer: (provided) => ({
														...provided,
														padding: "8px",
														padding: "2px 8px",
													}),
													hlgwow: (provided) => ({
														padding: "2px 8px",
														padding: "0px 8px",
													}),
													menu: (base) => ({
														...base,
														fontSize: "14px", // Change the font size of the menu
													}),
													placeholder: (base) => ({
														...base,
														fontSize: "12px",
													}),
												}}
											/>
											{errors.country != "" ? (
												<span className="text-danger">{errors.country}</span>
											) : null}
										</div>
									</div>

									{/* dropdown container end */}

									{/* number form container start*/}
									<div className="col-lg-12 pb-4">
										<div className="number-container d-flex flex-column gap-1 ">
											<label htmlFor="mobile-number" className="form-label">
												Enter Your Primary Number Only
											</label>
											<input
												id="mobile-number"
												className="form-control"
												placeholder="Enter Your Primary Number Only"
												type="text"
												value={number}
												maxLength="10"
												pattern="\d{10}"
												onChange={(e) => setNumber(e.target.value)}
											/>
											{errors.number != "" ? (
												<span className="text-danger">{errors.number}</span>
											) : null}
										</div>
									</div>
									{/* number form container end*/}

									{/* name input container start*/}
									<div className="col-lg-12 pb-4">
										<div className="name-container d-flex flex-column gap-1 ">
											<label htmlFor="user-name" className="form-label">
												Enter your name
											</label>
											<input
												id="user-name"
												className="form-control"
												placeholder="Enter your name"
												type="text"
												value={userName}
												onChange={(e) => setUserName(e.target.value)}
											/>
											{errors.username != "" ? (
												<span className="text-danger">{errors.username}</span>
											) : null}
										</div>
									</div>
									{/* name input container end*/}

									{/* email input container start*/}
									<div className="col-lg-12 pb-4">
										<div className="name-container d-flex flex-column gap-1 ">
											<label htmlFor="user-eamil" className="form-label">
												Enter your Email
											</label>
											<input
												className="form-control"
												placeholder="Enter your email"
												type="email"
												value={email}
												onChange={(e) => setEmail(e.target.value)}
											/>
											{errors.email != "" ? (
												<span className="text-danger">{errors.email}</span>
											) : null}
										</div>
									</div>
									{/* email input container end*/}

									{/* Dob input container start*/}
									<div className="col-lg-12">
										<div className="name-container d-flex flex-column gap-1 ">
											<label htmlFor="user-name" className="form-label">
												Enter your date of birth
											</label>
											<input
												type="date"
												placeholder="Enter your date of birth"
												className="form-control"
												value={selectedDate}
												onChange={(e) => setSelectedDate(e.target.value)}
											/>
											{errors.date != "" ? (
												<span className="text-danger">{errors.date}</span>
											) : null}
										</div>
									</div>
									{/* Dob input container end*/}

									{/* checkbox container start */}
									<div className="col-lg-12 mt-4 mb-2">
										<label className="form-label">Did you order the 10x Luck Report?</label>
										<div className="d-flex gap-2 align-items-center mt-2 ps-3">
											<div className="form-check form-check-inline d-flex align-items-center gap-2">
												<input
													type="radio"
													id="reportYes"
													name="orderReport"
													value="true"
													className="form-check-input fs-5"
													checked={orderReport === "true"}
													onChange={(e) => setOrderReport(e.target.value)}
												/>
												<label className="form-check-label" htmlFor="reportYes">
													Yes
												</label>
											</div>
											<div className="form-check form-check-inline d-flex align-items-center gap-2">
												<input
													type="radio"
													id="reportNo"
													name="orderReport"
													value="false"
													className="form-check-input fs-5"
													checked={orderReport === "false"}
													onChange={(e) => setOrderReport(e.target.value)}
												/>
												<label className="form-check-label" htmlFor="reportNo">
													No
												</label>
											</div>
										</div>
											{errors.orderReport && (
												<div className="text-danger">{errors.orderReport}</div>
											)}
									</div>
									{/* checkbox container end */}
									{orderReport === "false" && (
										<div className="dropdown-container d-flex flex-column gap-1 my-3">
											<label htmlFor="options" className="form-label">
												Please let us know the reason:
											</label>
											<Select
												className="basic-single"
												classNamePrefix="select"
												defaultValue={reasonOptions[0]}
												value={reason}
												isSearchable={true}
												name="luck_report_ordered"
												options={reasonOptions}
												onChange={handleReasonChange}
												menuPlacement="top"
												placeholder={"Select the reason"}
												styles={{
													control: (provided, state) => ({
														...provided,
														marginTop: "5px",
														minHeight: "36px",
														fontSize: "13px",
														border: state.isFocused
															? "1px solid #86b7fe"
															: "1px solid #ccc",
														boxShadow: state.isFocused
															? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
															: null,
													}),
													indicatorContainer: (provided) => ({
														...provided,
														padding: "8px",
														padding: "2px 8px",
													}),
													hlgwow: (provided) => ({
														padding: "2px 8px",
														padding: "0px 8px",
													}),
													menu: (base) => ({
														...base,
														fontSize: "12px",
														zIndex: 100,
													}),
													menuPortal: base => ({ ...base, zIndex: 9999 }),
													placeholder: (base) => ({
														...base,
														fontSize: "12px",
													}),
												}}
											/>
											{errors.country != "" ? (
												<span className="text-danger">{errors.reason}</span>
											) : null}
										</div>
									)}
									{orderReport === "false" && reason.value == "Other" && (
										<div className="col-lg-12 mt-4 mb-2">
											<label htmlFor="other-reason" className="form-label">
												Please let us know the reason
											</label>
											<textarea
												id="other-reason"
												rows="4"
												name="other-reason"
												className="form-control rounded mt-2"
												placeholder="Please let us know the reason"
												value={otherReason}
												onChange={(e) => setOtherReason(e.target.value)}
											/>
											{errors.OtherReason != "" ? (
												<span className="text-danger">
													{errors.OtherReason}
												</span>
											) : null}
										</div>
									)}

									{/* button container start */}
									<div className="button-container d-flex justify-content-center gap-2">
										<button
											type="button"
											onClick={handleSubmit}
											className="custom-button"
										>
											Submit
										</button>
										<button
											type="button"
											onClick={handleReset}
											className="custom-button"
										>
											Reset
										</button>
									</div>
									{/* button container end */}
								</div>
							</div>
						</form>
					</div>
				</div>

				{/* <div className="information-container text-center col-10 mx-auto">
                    <div className='title-container mx-auto'>
                        <h2>Benefits of Using a Numerology Calculator </h2>
                        <hr />
                    </div>
                    <div className="list-container">
                        <h4>Numerology can help you:</h4>
                        <ul>
                            <li>Gain deeper self-awareness</li>
                            <li>Understand your life purpose</li>
                            <li>Improve relationships by understanding compatibility</li>
                            <li>Make important life decisions with greater confidence</li>
                            <li>Find the ideal career or path that aligns with your true nature</li>
                        </ul>
                    </div>
                </div> */}
				{/* <div className="information-container text-center col-10 mx-auto">
                    <div className='title-container mx-auto'>
                        <h2>Destiny Number</h2>
                        <hr />
                    </div>
                    <p>The Destiny Number, also known as the Expression Number, is calculated from the letters in your full birth name. This number gives insight into your life’s purpose and the skills or talents you were born to develop. Find out your Destiny Number and what it means for you.</p>
                </div> */}
				{/* <div className="information-container text-center col-10 mx-auto mb-4 pb-4">
                    <div className='title-container mx-auto'>
                        <h2>Numerology and Career Choices</h2>
                        <hr />
                    </div>
                    <p>Your numerological profile can help guide you in choosing a career that aligns with your true strengths and talents. Discover how your Life Path and Destiny Numbers can reveal your ideal career path, helping you find greater fulfilment and success in your work life.</p>
                </div> */}
			</div>
		</>
	);
};

export default Numerology;
